import { useState } from "react";
import {
  Typography,
  TextField,
  Box,
  Grid
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CouponTemplateFormDto } from "../../../store/models/coupon/CouponManagementDto";

interface CouponBasicInfoStepProps {
  formData: CouponTemplateFormDto;
  updateFormData: (updates: Partial<CouponTemplateFormDto>) => void;
  readOnly?: boolean;
}

const CouponBasicInfoStep = ({ formData, updateFormData, readOnly = false }: CouponBasicInfoStepProps) => {
  const { t } = useTranslation();
  const [touchedFields, setTouchedFields] = useState<{[key: string]: boolean}>({});

  const handleFieldTouch = (fieldName: string) => {
    setTouchedFields(prev => ({ ...prev, [fieldName]: true }));
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#3859ff' }}>
        {t("coupon.form.couponName")}
      </Typography>

      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t("coupon.form.couponName")}
            value={formData.name}
            onChange={(e) => updateFormData({ name: e.target.value })}
            onBlur={() => handleFieldTouch('name')}
            placeholder={t("coupon.form.couponNamePlaceholder")}
            sx={{ backgroundColor: 'white' }}
            error={touchedFields.name && !formData.name.trim()}
            helperText={touchedFields.name && !formData.name.trim() ? t("coupon.form.errors.nameRequired") : ""}
            required
            disabled={readOnly}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CouponBasicInfoStep;
